import React from "react";

function Footer() {
    return (<section className="footer">Powered by Bythepay © 2024</section> );
}

export default Footer;
